<template>
    <div>
        <h1>Redirecting...</h1>
    </div>
</template>

<script>
import auth from "../services/auth";

export default {
    name: "signin",
    created() {
        auth.clientCredentials();
    }
};
</script>
